import { useMemo } from "react";
import { useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import API from "../../../services/API";
import { useContext } from "react";
import ToastContext from "../../../services/Context/ToastContext"
import uuid from 'react-uuid';
import useReorderChapters from "./useReorderChapters";
import { txt } from "../../../services/translation";

export default function useCreateChapter(){

    const {id} = useParams()

    const {setToast} = useContext(ToastContext)

    const queryClient = useQueryClient()

    const queryKey = useMemo(() => ['design', id, 'chapters'], [id]);

    const reorderChapters = useReorderChapters()

    return (rank) => {
        const oldChapters = [...queryClient.getQueryData(queryKey)];

        let newChapter = {
            id: uuid(),
            title: '',
            rank: rank - 0.5,
            course: {id: id},
            edit: true
        }

        let newChapters = [...queryClient.getQueryData(queryKey)];
        newChapters.push(newChapter);
        newChapters = reorderChapters(newChapters)
        queryClient.setQueryData(queryKey, newChapters);

        newChapter = newChapters.find(c => c.id === newChapter.id);

        API.post(`/design/chapters`, newChapter)
            .then(() => API.put(`/design/chapters/reorder`, newChapters))
            .catch(e => {
                queryClient.setQueryData(queryKey, oldChapters)

                setToast({
                    severity: 'error',
                    message: txt('errorOccurred')
                })
            })
    }
}